export enum PrefabID {
  SmallShrine = 'small_shrine',
  StorageRoom = 'storage_room',
  MerchantShop = 'merchant_shop',
  TreasureVault = 'treasure_vault',
  BossArena = 'boss_arena',
  Workshop = 'workshop',
}
